module.exports = __webpack_public_path__ + "static/media/canais-5.1b297398.jpg";